import {z} from 'zod';

import {base64ImageSchema} from '../common/Base64ImageSchema';

export const scanVINRequestSchema = z.object({
  imageBase64: base64ImageSchema,
});

export type ScanVINRequest = z.infer<typeof scanVINRequestSchema>;
